/** 时间间隔的Key对应的多语言key */
export const KlineMap = { 1: 'P1m', 5: 'P5m', 15: 'P15m', 30: 'P30m', 60: 'P1h', 240: 'P4h', D: 'P1d', W: 'P1w', M: 'P1M', '12M': 'P1y' };
/** K线默认的时间间隔 */
export const MainTimeType = ['15', '60', '240', 'D'];
/** K线更多的时间间隔 */
export const MoreTimeType = ['1', '5', '30', 'W', 'M', '12M'];
/** 主图 */
export const MainIndicators = ['MA', 'EMA', 'BOLL'];
/** 副图 */
export const SecondIndicators = ['MACD', 'KDJ', 'RSI', 'WR'];

export type ITimeType = keyof (typeof KlineMap);
